// /*TODO [vue-i18n-set-up] move to a more suitable folder location and refactor - this is temporary code while translation strings are being set up*/
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import EnglishComponentTranslations from '../../lang/en/js/components.json'
import GermanComponentTranslations from '../../lang/de/js/components.json'
const componentsInEnglish = Object.assign(EnglishComponentTranslations)
const componentsInGerman = Object.assign(GermanComponentTranslations)

Vue.use(VueI18n)

const messages = {
    en: {
        components: componentsInEnglish
    },
    de: {
        components: componentsInGerman
    }
}

import { getViewData } from 'assets/js/modules/view-data';

export const i18n = new VueI18n({
    locale: getViewData('env.PREFERRED_LANGUAGE'),
    messages
})
